import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { CRUDFunction } from "../../../../reduxCURD/container";
import ExecutionTable from "./ExecutionTable";
import { languageService } from "../../../../Language/language.service";
import { deriveCRUDNames } from "../../crudHelpers";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { DashboardPageStyle } from "../../../Dashboard/styles/DashboardPageStyle";
import { commonStylesDashboard } from "../../../Dashboard/styles/commonStylesDashboard";
import { CommonWidgetMethods } from "../Common";
import { dateSortArrayByField } from "../../../../utils/sortingMethods";

import PropagateLoader from "react-spinners/PropagateLoader";
class ExecutionListWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      executionDataToShow: [],
      listPage: 0,
      spinnerLoading: false,
    };
    this.fetchCall = this.fetchCall.bind(this);
  }
  fetchCall(settings, dateRange, filterLocations) {
    let sett = settings.map((s) => {
      return { ...s, lineIds: filterLocations };
    });
    // const url = `summary?settings=${JSON.stringify(sett)}&dateRange=${JSON.stringify(dateRange)}`;

    // this.props.getExecutionsLists(url);
    this.props.createExecutionsList(
      {
        settings: sett,
        dateRange: dateRange,
      },
      "WidgetSettings",
      "/summary",
    );
  }
  componentDidMount() {
    const { settings } = this.props.settings;
    const { dateRange, filterLocations } = this.props;

    this.fetchCall(settings, dateRange, filterLocations);
  }

  componentDidUpdate(prevProps) {
    const { settings, widgetId } = this.props.settings;
    const { dateRange, actionType, filterLocations, executionsLists } = this.props;

    if (actionType === "EXECUTIONSLIST_CREATE_REQUEST" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }

    const dateChanged = dateRange.month !== prevProps.dateRange.month || dateRange.year !== prevProps.dateRange.year;

    if (dateChanged || filterLocations !== prevProps.filterLocations) {
      this.fetchCall(settings, dateRange, filterLocations);
    }

    if (actionType === "EXECUTIONSLIST_CREATE_SUCCESS" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: false, executionDataToShow: executionsLists });
    }

    if (actionType === "EXECUTIONSLIST_CREATE_FAILURE" && actionType !== prevProps.actionType) {
      console.error("Failed to fetch execution data.");
      this.setState({ spinnerLoading: false });
    }
  }

  handlePageStateSave = (page) => {
    this.setState({ listPage: page });
    this.setState({ spinnerLoading: false });
  };
  getCombinedData() {
    const { executionDataToShow } = this.state;
    let executionList = executionDataToShow ? executionDataToShow.executionList : {};
    let list = [];

    if (executionList && executionList.lines) {
      Object.entries(executionList.lines).forEach(([id, val]) => {
        list.push(...val.list);
      });
    }

    return list;
  }
  render() {
    const { executionDataToShow, spinnerLoading } = this.state;
    let filteredData = this.getCombinedData();
    let sorted = filteredData.sort((a, b) => {
      const numA = parseInt(a.title.split("#")[1], 10);
      const numB = parseInt(b.title.split("#")[1], 10);
      return numB - numA; // Reverse order
    });
    if (spinnerLoading || !executionDataToShow) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
          <PropagateLoader
            color={themeService({ default: "rgb(55, 139, 119)", retro: "var(--first)", electric: "rgba(64, 118, 179,.5)" })}
            sizeUnit={"px"}
            size={10}
          />
        </div>
      );
    }

    return (
      <div md="12" style={{ padding: "20px", margin: 0, backgroundColor: "white", height: "100%" }}>
        <Row style={{ ...themeService(DashboardPageStyle.headingRow), marginBottom: "15px" }}>{languageService("Maintenance")}</Row>
        <Row style={themeService(DashboardPageStyle.tablesContainerRow)}>
          <Col style={{ ...themeService(commonStylesDashboard.innerContainerCol), padding: 0, margin: 0 }}>
            <ExecutionTable executionList={sorted} pageSize={8} pagination={true} />
          </Col>
        </Row>
      </div>
    );
  }
}

const actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
};

const ExecutionListWidgetContainer = CRUDFunction(ExecutionListWidget, "executionsList", actionOptions, null, [], "dashboard");
export default ExecutionListWidgetContainer;
//



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/ExecutionListWidget/ExecutionListWidget.jsx